export default "__VITE_ASSET__mWgbc6GG__"